import { render } from "./IconShield.vue.js?vue&type=template&id=5f104046!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconShield.vue?vue&type=template&id=5f104046"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__